import { useEffect, useState } from "react";
import { Modal, Form, Select, Button, Switch, InputNumber, Input } from "antd";
import { useLocation, useNavigate } from "react-router-dom";

import API from "scripts/api";
import { Modals } from "scripts/settings";
import Resources from "scripts/resources";
import TextArea from "antd/lib/input/TextArea";

const CourseSoundModal = ({ data, onUpdate, options }) => {
  const { hash } = useLocation();
  const navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isCreate = hash.includes(`${Modals.CREATE}_${Modals.SOUND}`);
  const isEdit = hash.includes(`${Modals.EDIT}_${Modals.SOUND}`);

  const open = isCreate || isEdit;

  useEffect(() => {
    if (!open) return;

    if (data && isEdit) {
      form.setFieldsValue({
        sound: data?.sound?.id,
        duration: data?.duration,
        locked: data?.locked,
        status: data?.status,
      });
    } else {
      form.resetFields();
    }
  }, [open, data]);

  const closeModal = () => {
    navigate(-1);
  };

  const handleSubmit = () => {
    form.validateFields().then((values) => {
      setLoading(true);

      const payload = {
        courseId: data?.id || data?.courseId,
        soundId: values.sound,
        duration: values.duration,
        locked: values.locked,
        status: values.status,
        type: "sound"
      };

      const request = isEdit
        ? API.session.update(data.code, payload)
        : API.session.create(payload);

      request
        .then(() => {
          onUpdate(data, true);
          closeModal();
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <Modal
      open={open}
      title={
        isEdit
          ? `${Resources.edit} ${Resources.soundFile}`
          : `${Resources.add} ${Resources.soundFile}`
      }
      onCancel={closeModal}
      // footer={null}
      destroyOnClose
    >
      <Form layout="vertical" form={form}>
        <Form.Item
          name="sound"
          label={Resources.soundFile}
          rules={[{ required: true }]}
        >
          <Select
            options={options?.sounds}
            placeholder={Resources.select}
            showSearch
            optionFilterProp="label"
          />
        </Form.Item>

		<Form.Item
			name="title"
			label={Resources.title}
			// rules={Rules.required}
		>
		<Input />
		</Form.Item>

		<Form.Item
			name="description"
			label={Resources.description}
		>
		<TextArea />
		</Form.Item>

        <Form.Item name="duration" label={Resources.duration}>
          <InputNumber style={{ width: "100%" }} min={0} />
        </Form.Item>


        <Button
          type="primary"
          block
          loading={loading}
          onClick={handleSubmit}
        >
          {Resources.save}
        </Button>
      </Form>
    </Modal>
  );
};

export default CourseSoundModal;